export default {

    ARTICLE: {
        code: 1,
        title: '资讯'
    },
    ATLAS: {
        code: 2,
        title: '图集'
    },
    VOD: {
        code: 3,
        title: '点播课程'
    },
    DATUM: {
        code: 4,
        title: '资料'
    },
    VOICE: {
        code: 5,
        title: '每日一听'
    },
    AD: {
        code: 6,
        title: '广告'
    },
    ORTHER_AD: {
        code: 7,
        title: '其他广告'
    },
    VIP: {
        code: 16,
        title: 'VIP'
    },
    COUPON_ACTIVITY: {
        code: 17,
        title: '优惠券活动'
    },
    INDEX_TOPIC: {
        code: 18,
        title: '主题包'
    },
    PACKAGE: {
        code: 19,
        title: '专题包'
    },
    AUDIO: {
        code: 20,
        title: '音频课程'
    },
    AUDIO_SEG: {
        code: 21,
        title: '音频课程小节'
    },
    THIRD_PARTY: {
        code: 23,
        title: '第三方工具服务/实物'
    },
    PRE_PAY: {
        code: 34,
        title: '提前购'
    },
    SECOND_KILL: {
        code: 38,
        title: '秒杀'
    },
    FAMOUS_TEACHER: {
        code: 39,
        title: '名师名课/专题课程'
    },
    UNDERLINE_COURSE: {
        code: 41,
        title: '线下课'
    },
    DISTRIBUTION_ROLE: {
        code: 44,
        title: '分销角色'
    },
    ALBUM: {
        code: 45,
        title: '相册'
    },
    SHIXUN_MOMENT: {
        code: 46,
        title: '师圈文章/视频'
    },
    COMMENT: {
        code: 47,
        title: '评论'
    },


    /**
     * @param   String  title   biz type's title
     * @returns String          biz type's key
     * @author  zhiwen
     */
    getKeyByTitle : function (title) {

        for (let key in this)
        {
            if (typeof(this[key]) != 'object')
            {
                continue;
            }

            if (this[key].title == title)
            {
                return key;
            }
        }

        return '';
    },

    /**
     * @param   String  title   biz type's title
     * @returns String|Number   biz type's code
     * @author  zhiwen
     */
    getCodeByTitle : function (title) {

        for (let key in this)
        {
            if (typeof(this[key]) != 'object')
            {
                continue;
            }

            if (this[key].title == title)
            {
                return this[key].code;
            }
        }

        return '';
    }

}
